<template>
  <div class="shop-page">
    
      <Header />
      <SmoothScroll>
         <PageTitle :pageTitle="'ჟუჟუნას მაღაზია'" :titleColor="'#F49CB8'"  />
         
            <ProductsList />
        <Footer />
      </SmoothScroll>
  </div>
</template>

<script>
import SmoothScroll from '@/components/SmoothScroll';

import PageTitle from '@/components/layout/PageTitle';
import ProductsList from '@/components/smartComponents/ProductsList';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
export default {
components: {SmoothScroll, Header, PageTitle, Footer, ProductsList},
}
</script>

<style>

</style>